import { Button, Grid, Paper, styled, Typography } from "@mui/material";

export const StyledPasswordRecoveryContainer = {
  Text: styled(Typography)({
    color: "#303030",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bold",
    fontSize: "medium",
  }),

  GridContainer: styled(Grid)({
    flex: 1,
    alignItems: "center",
    backgroundImage: "linear-gradient(120deg, #96d43a, #539aff)",
  }),

  GridRowItem: styled(Grid)({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  }),

  GridItemAligned: styled(Grid)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: 10,
  }),

  LogoStyled: styled("img")({
    paddingBottom: "60px",
  }),

  LoginCard: styled(Paper)({
    minWidth: "450px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px grey",
    borderRadius: "10px",
    padding: "30px 25px 10px 25px",
  }),

  ButtonStyled: styled(Button)(({ theme }) => ({
    marginTop: 20,
    backgroundColor: theme.palette.primary.gradientLogin2,
  })),
};
